export default __webpack_public_path__ + "static/favicon-152-touch-9831c4ff49cddec7790ae8c706caf355.png";